module.exports = __webpack_public_path__ + "static/img/icon_extend.d1a80d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon_extend.svg
// module id = 395
// module chunks = 12